import { parseSearchString } from 'lib/url/searchUrlUtils'
import { createSelector } from 'reselect'
import moment from 'moment'

export const getImmersiveTripId = (state: App.State) =>
  state.tripPlanner.currentTripId

export const selectTripPlannerTemplateId = createSelector(
  (state: App.State) => state.router.location.search,
  (search): string | undefined => {
    const params = parseSearchString(search)
    return params.templateId
  },
)

export const selectTripPlannerTemplateItemId = createSelector(
  (state: App.State) => state.router.location.search,
  (search): string | undefined => {
    const params = parseSearchString(search)
    return params.templateItemId
  },
)

export const selectHotelData = createSelector(
  (state: App.State, orderId: string) => state.orders.orders[orderId],
  (state: App.State) => state.offer.offers,
  (order, offers) => {
    const item = order?.items[0]
    if (!item?.offer?.property) return
    const offerId = item.offerId || item.offer.id
    const specificOffer = offers[offerId]

    let checkInTime = '15:00'
    let checkOutTime = '11:00'

    if (specificOffer?.facilities) {
      const facilityLine = specificOffer.facilities
        .split('\n')
        .find((line) => line.includes('Check-in:'))

      if (facilityLine) {
        const times = facilityLine.match(/\d+(\.\d+)?\w+/g)
        if (times && times.length === 2) {
          const [checkInRaw, checkOutRaw] = times
          checkInTime = moment(checkInRaw, 'hA').format('HH:mm')
          checkOutTime = moment(checkOutRaw, 'hA').format('HH:mm')
        }
      }
    }

    return {
      hotelCountry: item.offer.property.locationSubheading,
      hotelCity: item.offer.property.locationHeading,
      propertyId: item.offer.property.address,
      checkInDate: item.reservation?.startDate ? moment(item.reservation.startDate).format('YYYY-MM-DD') : undefined,
      checkOutDate: item.reservation?.endDate ? moment(item.reservation.endDate).format('YYYY-MM-DD') : undefined,
      numberOfNights: item.duration,
      numberOfAdults: item.reservation?.adults,
      numberOfChildren: item.reservation?.children,
      numberOfInfants: 0,
      checkInTime,
      checkOutTime,
      offerId: item.offerId,
    }
  },
)

export const selectBedbankData = createSelector(
  (state: App.State, orderId: string) => state.orders.orders[orderId],
  (order) => {
    const item = order?.bedbankItems[0]
    if (item?.offer?.property) {
      return {
        hotelCountry: item.offer.property.address.countryName,
        hotelCity: item.offer.property.address.city,
        propertyId: item.offer.property.address.line1,
        checkInDate: item.checkIn ? item.checkIn.format('YYYY-MM-DD') : undefined,
        checkOutDate: item.checkOut ? item.checkOut.format('YYYY-MM-DD') : undefined,
        numberOfNights: item.duration,
        numberOfAdults: item.rooms[0].occupancy.adults,
        numberOfChildren: item.rooms[0].occupancy.children,
        numberOfInfants: 0,
        checkInTime: item.offer.property.finePrint?.checkIn?.beginTime || '14:00',
        checkOutTime: item.offer.property.finePrint?.checkOut?.time || '11:00',
        offerId: item.offer.id,
      }
    }
  },
)

export const selectTransferData = createSelector(
  (state: App.State, orderId: string) => state.orders.orders[orderId],
  (state: App.State) => state.experience.experiences,

  (order, experiences) => {
    if (!order?.transferItems || order.transferItems.length === 0) {
      return []
    }
    return order.transferItems.map((transferItem: App.OrderTransferItem) => {
      const experienceData = experiences[transferItem.experienceId]
      return {
        name: experienceData.name,
        startDate: transferItem.date,
        place: {
          name: experienceData.location.name,
          region: experienceData.location.name,
          point: {
            lat: experienceData.location.latitude,
            lng: experienceData.location.longitude,
          },
          photoUrl: experienceData.images[0]?.url,
        },
        price: transferItem.price,
        notes: 'Check MyEscapes for more details about your transfer.',
        url: '',
        isBooked: true,
        type: transferItem.type,
      }
    })
  },
)
